import api from './api';
import type { CrmOportunidadAdjunto } from '../types/crm';

const crmAdjuntoService = {
  list: async (oportunidadId: number): Promise<CrmOportunidadAdjunto[]> => {
    const response = await api.get<CrmOportunidadAdjunto[]>(
      `/api/CrmOportunidades/${oportunidadId}/adjuntos`,
    );
    return response.data ?? [];
  },

  upload: async (oportunidadId: number, file: File): Promise<CrmOportunidadAdjunto> => {
    const form = new FormData();
    form.append('archivo', file);
    const response = await api.post<CrmOportunidadAdjunto>(
      `/api/CrmOportunidades/${oportunidadId}/adjuntos`,
      form,
    );
    return response.data;
  },

  fetchBlob: async (
    oportunidadId: number,
    adjuntoId: number,
    download = false,
  ): Promise<Blob> => {
    const response = await api.get<Blob>(
      `/api/CrmOportunidades/${oportunidadId}/adjuntos/${adjuntoId}`,
      {
        params: download ? { download: true } : undefined,
        responseType: 'blob',
      },
    );
    return response.data;
  },

  remove: async (oportunidadId: number, adjuntoId: number): Promise<void> => {
    await api.delete(`/api/CrmOportunidades/${oportunidadId}/adjuntos/${adjuntoId}`);
  },
};

export default crmAdjuntoService;
